<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="field">
    <label>Usuário de banco</label>
    <input pInputText [value]="dbUsername" class="w-full" [disabled]="true" />
  </div>

  <div class="field">
    <label for="password">Senha</label>
    <input
      pInputText
      id="password"
      type="password"
      formControlName="password"
      placeholder="Mínimo 8 caracteres"
      class="w-full"
    />
    <small
      class="p-error"
      *ngIf="
        form.get('password')?.touched &&
        form.get('password')?.hasError('required')
      "
    >
      Senha é obrigatória.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('password')?.touched &&
        form.get('password')?.hasError('minlength')
      "
    >
      Mínimo 8 caracteres.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('password')?.touched &&
        form.get('password')?.hasError('uppercase')
      "
    >
      Deve conter pelo menos uma letra maiúscula.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('password')?.touched &&
        form.get('password')?.hasError('number')
      "
    >
      Deve conter pelo menos um número.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('password')?.touched &&
        form.get('password')?.hasError('specialChar')
      "
    >
      Deve conter pelo menos um caractere especial.
    </small>
  </div>

  <div class="field">
    <label for="passwordConfirmation">Confirmação de senha</label>
    <input
      pInputText
      id="passwordConfirmation"
      type="password"
      formControlName="passwordConfirmation"
      placeholder="Repita a senha"
      class="w-full"
    />
    <small
      class="p-error"
      *ngIf="
        form.get('passwordConfirmation')?.touched && form.hasError('mismatch')
      "
    >
      Senha e confirmação não conferem.
    </small>
  </div>

  <div class="flex justify-content-end gap-2 mt-4">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="ref.close(false)"
    ></button>
    <button
      pButton
      type="submit"
      label="Criar login"
      [disabled]="form.invalid"
    ></button>
  </div>
</form>
